// Configuración centralizada
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  isDevelopment: process.env.REACT_APP_ENV === 'development',
  tokenKey: 'psych_app_token',
  userKey: 'psych_app_user'
};

export default config;
